import { render, staticRenderFns } from "./AdminTravels.vue?vue&type=template&id=3ca9892c"
import script from "./AdminTravels.vue?vue&type=script&lang=js"
export * from "./AdminTravels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports